"use client"

import * as React from "react"
import { cn } from "@/lib/utils"

export type TimePickerProps = {
  value?: string
  onChange?: (value: string) => void
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, "value" | "onChange">

function TimePicker({ ref, className, value, onChange, ...props }: TimePickerProps & { ref?: React.RefObject<HTMLInputElement | null> }) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value
    onChange?.(newValue)
  }

  return (
    <input
      ref={ref}
      className={cn(
        "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      onChange={handleChange}
      type="time"
      value={value || ""}
      {...props}
    />
  )
}

TimePicker.displayName = "TimePicker"

export { TimePicker }
